import { useFiltro } from '../estado/filtros.js';

const OPCOES = [
  { valor: '' as const, rotulo: 'Todas', dica: 'Emitidas e tomadas juntas' },
  { valor: 'emitida' as const, rotulo: 'Emitidas', dica: 'Notas em que esta empresa é a emitente' },
  { valor: 'tomada' as const, rotulo: 'Tomadas', dica: 'Notas em que esta empresa é a destinatária' },
];

/**
 * Fica acima do conteúdo porque o recorte vale para todas as telas: resumo,
 * documentos, obras e análise leem o mesmo filtro. Emitida e tomada não somam
 * a mesma coisa — uma é receita, a outra é custo — e misturá-las sem perceber
 * é o erro mais fácil de cometer nesta tela.
 */
export function SeletorPapel() {
  const { filtro, definir } = useFiltro();

  return (
    <div className="papel-sel" role="group" aria-label="Recorte por papel do documento">
      {OPCOES.map((o) => (
        <button
          key={o.valor}
          type="button"
          className="papel-opt"
          aria-pressed={filtro.papel === o.valor}
          title={o.dica}
          onClick={() => definir({ papel: o.valor })}
        >
          {o.rotulo}
        </button>
      ))}
    </div>
  );
}
